// extracted by mini-css-extract-plugin
export default {"properties-container":"Properties_properties-container__rVJo6"};